import PropTypes from "prop-types";
import "./ExperienceSection.css";

function ExperienceSection({ highlights }) {
  return (
    <section className="experience" id="experience" data-reveal>
      <div className="experience__content">
        <div className="experience__header">
          <span className="experience__eyebrow">Credibility</span>
          <h2 className="experience__title">Proven results across startups, scale-ups, and enterprises.</h2>
          <p className="experience__description">
            Every engagement combines executive-level perspective with hands-on delivery, working shoulder-to-shoulder with internal teams to deliver measurable outcomes. Here is a snapshot of recent impact.
          </p>
        </div>
        <div className="experience__list">
          {highlights.map((item, index) => (
            <article
              key={item.client}
              className="experience-card"
              data-reveal
              data-reveal-delay={index * 100}
            >
              <div className="experience-card__client">{item.client}</div>
              <h3 className="experience-card__headline">{item.headline}</h3>
              <p className="experience-card__detail">{item.detail}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

ExperienceSection.propTypes = {
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      client: PropTypes.string.isRequired,
      headline: PropTypes.string.isRequired,
      detail: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ExperienceSection;
